import { styled } from "@mui/material";

import Input from "../../../../../components/Form/Input";

export const SearchIconContainer = styled("div")(() => ({
  cursor: "pointer",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const SearchInput = styled(Input)(() => ({
  width: "200px",
}));
